import { AppVBOWaardecheckAppraisalRequestPointerParameterValue } from '~/scenes/Automation/Flows/Actions/Base/types.flow';

import { PARAMETER_VALUE_TYPE } from '../../../constants';

export default (): AppVBOWaardecheckAppraisalRequestPointerParameterValue => ({
  type: PARAMETER_VALUE_TYPE.EVENT_CONTACT_APP_VBOWAARDECHECK_APPRAISALREQUEST_POINTER,
  variable: null,
});
